"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

/**
 * Promisified timeout.
 */
exports.default = function (time) {
  return new Promise(function (resolve) {
    return setTimeout(function () {
      return resolve();
    }, time);
  });
};


//////////////////
// WEBPACK FOOTER
// ./src/common/utils/lib/delay.js
// module id = 2293
// module chunks = 0